(function () {
    angular.module('rightPaneModule')
      .directive('dblLessonImage', [
          function () {
              return {
                  restrict: 'E',
                  templateUrl: '/resources/right-pane/components/activity-feed/dbl-lesson-image.directive.html',
                  scope: {
                      dblDemoLink: '=',
                      dblHideDemoButtonText: '=',
                      dblImageSrc: '=',
                      dblLessonSlotName: '=',
                      dblAnalyticsCategory: '=',
                      dblShowGroup: '='
                  },
                  controller: [
                      'dblLessonService',
                      '$scope',
                      DblLessonImageController]
              };
          }
      ]);

    function DblLessonImageController(
      dblLessonService,
      $scope
    ) {
        $scope.getDemoButtonClass = getDemoButtonClass;
        $scope.getDemoButtonText = getDemoButtonText;

        function getDemoButtonClass() {
            return !$scope.dblDemoLink ? 'no-activity-demo disabled' : '';
        }

        function getDemoButtonText() {
            if ($scope.dblHideDemoButtonText) {
                return '';
            }

            return dblLessonService.getDemoButtonText(!!$scope.dblDemoLink, !$scope.dblShowGroup);
        }
    }
})();
